module.exports = __webpack_public_path__ + "static/media/Tanzania-Queen-and-Son-small-mobile.544559a1.jpg";